import Grid from 'apollo-react/components/Grid';
import React from 'react';

import ControlPropertiesTable from './ControlPropertiesTable';
import { useFormSelector } from '../../../../custom-hooks';
import { getUITA } from '../../../../utils/commonUtils';
import { ALL_SUPPORTED_UPDATE_ACTIONS_TYPES } from '../../../constants/editor.constants';
import {
  getDeltaChangesUpdateRules,
  getUpdateRules,
  hasControlPropChangesForUpdateRules,
} from '../../../selectors/editor.selectors';
import { equalityFn } from '../../../utils/form-manager.utils';

const columns = [
  {
    header: 'Type',
    accessor: 'dummyType',
  },
  {
    header: 'Target',
    accessor: 'dummyTarget',
  },
];

const ControlPropertiesUpdate = ({ controlId, classes, handleClick }) => {
  const updateRules = useFormSelector(
    getUpdateRules,
    {
      id: controlId,
    },
    equalityFn
  );

  const deltaChanges = useFormSelector(
    getDeltaChangesUpdateRules,
    {
      id: controlId,
    },
    equalityFn
  );

  const hasUIChange = useFormSelector(
    hasControlPropChangesForUpdateRules,
    {
      id: controlId,
    },
    equalityFn
  );

  return (
    <Grid item xs={12} ui-ta={getUITA('Control Properties Update')}>
      <ControlPropertiesTable
        title="Update"
        type="update"
        classes={classes}
        columns={columns}
        rows={updateRules.filter((rule) => ALL_SUPPORTED_UPDATE_ACTIONS_TYPES.includes(rule.type))}
        hasUIChange={hasUIChange}
        deltaChanges={deltaChanges}
        handleClick={handleClick}
      />
    </Grid>
  );
};

export default React.memo(ControlPropertiesUpdate);
